import { Uuid } from "../../domain/model/uuid/uuid.type";
import { WeighingType } from "../../domain/model/weighing-type";
import { PigGenderViewModel } from "./pig-gender.viewmodel";
import { UpdateInfoViewModel } from "./update.viewmodel";

export class BatchWeighingViewModel {
  constructor(
    readonly id: Uuid,
    readonly animalWeighingIds: Uuid[],
    readonly batchId: Uuid,
    readonly sectionId: Uuid,
    readonly trialId: Uuid,
    readonly batchNumber: number,
    readonly batchName: string,
    readonly weighingType: WeighingType,
    readonly pigGender: PigGenderViewModel,
    readonly update: UpdateInfoViewModel,
    readonly adjacentBws: { previousBwId: string | undefined; nextBwId: string | undefined }
  ) {  }

  toString(): string {
    return `Id: ${this.id}, SectionId: ${this.sectionId}, TrialId: ${this.trialId}, WeighingType: ${this.weighingType}, PigGender: ${this.pigGender}`;
  }
}
